import feedbacks from "../services/feedbacks";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        errors: null,
        loading: false,
        notification: null,
        view: null,
        list: [],
        page: 1,
        perPage: 10,
        prevPage: null,
        nextPage: null,
        maxPage: null,
        startList: null,
        endList: null,
        message: null,
        search: {
            keyword: null,
            filter: null,
            dateFrom: null,
            dateTo: null
        },
        feedbackInfo: {
            customer_name: null,
            mobile_number: null,
            profile_image: null,
            date_created: null,
            time_created: null,
            message: null,
            replied_by: null,
            date_replied: null,
            time_replied: null,
            reply: null
        },
        uuid: null,
        reply: null
    },
    mutations: {
        setSearchFilter(state, filter) {
            state.search.keyword = filter.keyword;
            state.search.filter = filter.field == "all" ? null : filter.field;
            state.search.dateTo = filter.dateTo;
            state.search.dateFrom = filter.dateFrom;
        },
        setSearchDefault(state) {
            state.search.keyword = null;
            state.search.filter = null;
        },
        setList(state, response) {
            state.list = response.list;
            state.maxPage = response.max_page;
            state.nextPage = response.next_page;
            state.prevPage = response.prev_page;

            if (state.page == 1) {
                state.startList = 1;
            } else {
                state.startList = state.perPage * (state.page - 1) + 1;
            }

            if (state.page == state.maxPage) {
                let count = state.list.length;
                state.endList = state.perPage * (state.page - 1) + count;
            } else {
                state.endList = state.perPage * state.page;
            }
            state.message = response.message;
        },
        setFeedbackInfo(state, response) {
            state.feedbackInfo.customer_name = response.feedback_by;
            state.feedbackInfo.mobile_number = response.mobile_number;
            state.feedbackInfo.profile_image = response.profile_image;
            state.feedbackInfo.date_created = response.date_created;
            state.feedbackInfo.time_created = response.time_created;
            state.feedbackInfo.message = response.message;
            state.feedbackInfo.replied_by = response.replied_by;
            state.feedbackInfo.date_replied = response.date_replied;
            state.feedbackInfo.time_replied = response.time_replied;
            state.feedbackInfo.reply = response.reply;
        },
        getNext(state) {
            state.page = state.nextPage;
        },
        getPrev(state) {
            state.page = state.prevPage;
        },
        getFirstPage(state) {
            state.page = 1;
        },
        setPage(state, page) {
            state.page = page;
        },
        setReplyDefault(state) {
            state.feedbackInfo.reply = "";
        },
        setReply(state, reply) {
            state.reply = reply;
        },
        setUuid(state, uuid) {
            state.uuid = uuid;
        },
        loading(state, value = true) {
            state.loading = value;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        }
    },
    actions: {
        getFirstPage({ commit, dispatch }) {
            commit("getFirstPage");
            dispatch("getList");
        },
        getList: async ({ commit, state }) => {
            try {
                let response = await feedbacks.getList(
                    state.page,
                    state.search
                );
                commit("setList", response);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        getFeedbackInfo: async ({ commit, state }) => {
            commit("loading");
            try {
                let response = await feedbacks.getFeedbackInfo(state.uuid);
                commit("setFeedbackInfo", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        sendReply: async ({ commit, state }) => {
            commit("loading");
            try {
                let response = await feedbacks.sendReply({
                    message: state.reply,
                    feedback_uuid: state.uuid
                });

                // dispatch("getList");
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        exportFeedback: async ({ commit, state }) => {
            commit("loading");
            commit("errors", null);
            
            try {
                let response = await feedbacks.export(state.search);
                window.open(response.url, "_blank");
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        }
    }
};
